
const Category = (state) => state.Category;
const Categories = (state) => state.Categories;
const TotalInfo = (state) => state.TotalInfo;
export default { Category, Categories, TotalInfo }